var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIconPropertylisting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 18.0596V4.72624C13.3327 4.28421 13.1571 3.86029 12.8445 3.54773C12.532 3.23516 12.108 3.05957 11.666 3.05957H8.33268C7.89066 3.05957 7.46673 3.23516 7.15417 3.54773C6.84161 3.86029 6.66602 4.28421 6.66602 4.72624V18.0596M3.33268 6.3929H16.666C17.5865 6.3929 18.3327 7.1391 18.3327 8.05957V16.3929C18.3327 17.3134 17.5865 18.0596 16.666 18.0596H3.33268C2.41221 18.0596 1.66602 17.3134 1.66602 16.3929V8.05957C1.66602 7.1391 2.41221 6.3929 3.33268 6.3929Z",
    stroke: "#344054",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconPropertylisting);
export default __webpack_public_path__ + "static/media/nav-icon-propertylisting.292bd6f50113223111d1d61dd7e50dff.svg";
export { ForwardRef as ReactComponent };